module.exports = __webpack_public_path__ + "media/fonts/Oricons-c130e82c0c27a64b34e4ae8179cabbd4.woff";